import styled from '@emotion/styled';
import { Button, InputFormContainer, Modal } from '@ui-components/neo.tax';

export const SupportingDocumentsInputFormContainer = styled(InputFormContainer)({
  margin: 0,
});

export const SupportingDocumentsButton = styled(Button)({
  width: '100%',
  marginTop: 8,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
});

export const ModalStyled = styled(Modal)({
  width: 540,
  maxWidth: 540,
});
